import React, { useState } from "react";
import { Box } from "@mui/material";
import { CreateButton } from "@refinedev/mui";

import { DataGrid } from "@shared/components/DataGrid";
import { FilterDropdown } from "@shared/components";
import {
  CreateConfigModal,
  EditConfigModal,
  ConfigListFilters,
} from "@modules/erpIntegrations/components";
import { PlaygroundDialog } from "@modules/erpIntegrations/components/PlaygroundDialog";
import { AgreementIntegrationConfig } from "@modules/erpIntegrations/types";

import { useConfigsTab } from "./controller";
import { useConfigsColumns } from "./columns";

export const ConfigsTab = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    integrations,
    agreementNameById,
    createModalRef,
    editModalRef,
    refetch,
    translate,
    handleDelete,
  } = useConfigsTab();
  const [playgroundConfig, setPlaygroundConfig] = useState<AgreementIntegrationConfig | null>(null);

  const columns = useConfigsColumns(
    translate,
    editModalRef,
    handleDelete,
    setPlaygroundConfig,
    agreementNameById
  );

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1 }}>
        <FilterDropdown
          paramPrefix="configs_"
          initialValues={{ agreement: "", integration: "", plan_map_option: "" }}
        >
          <ConfigListFilters />
        </FilterDropdown>
        <CreateButton onClick={() => createModalRef.current?.open()} />
      </Box>

      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        sortingOrder={["asc", "desc"]}
      />

      <CreateConfigModal
        integrations={integrations}
        onComplete={() => refetch()}
        modalRef={createModalRef}
      />
      <EditConfigModal
        integrations={integrations}
        onComplete={() => refetch()}
        modalRef={editModalRef}
      />
      <PlaygroundDialog
        config={playgroundConfig}
        onClose={() => setPlaygroundConfig(null)}
        onDone={() => refetch()}
      />
    </>
  );
});
